import React from 'react';

import { ContextGlobal as CG } from 'contexts';
import { useForm } from 'components/form';
import * as Form from 'components/form';
import * as Page from 'components/page';

import * as Styled from './StyledContratos';

// Soft, non-blocking hint for the most common free providers. The authoritative
// control on the server is existence-gating (the e-mail must already be a
// registered counterparty contact), so startups using free e-mail still work.
const FREE_PROVIDERS = [
    'gmail.com',
    'googlemail.com',
    'hotmail.com',
    'outlook.com',
    'live.com',
    'msn.com',
    'yahoo.com',
    'ymail.com',
    'icloud.com',
    'me.com',
    'aol.com',
    'proton.me',
    'protonmail.com',
    'uol.com.br',
    'bol.com.br',
    'terra.com.br',
];

export function ContratosEmail({ t, cv, onSent }) {
    const { emitAlert, state } = React.useContext(CG);
    const [freeWarn, setFreeWarn] = React.useState(false);
    const form = useForm({ email: cv.email || '' });

    const onChangeEmail = ev => {
        const value = String(ev?.target?.value || '').toLowerCase();
        const domain = value.split('@')[1];
        setFreeWarn(Boolean(domain) && FREE_PROVIDERS.includes(domain));
    };

    const onSubmit = values => {
        const email = String(values.email || '')
            .trim()
            .toLowerCase();
        return cv
            .requestPin({ email, locale: state.language })
            .then(() => {
                form.submited();
                onSent(email);
            })
            .catch(err => {
                form.submited();
                const code = err?.response?.data?.code;
                emitAlert(code === 'INVALID_EMAIL' ? t('email.invalid') : t('errors.generic'));
            });
    };

    const fields = {
        email: {
            autoComplete: 'email',
            autoFocus: true,
            error: form.errors.email,
            label: t('email.label'),
            name: 'email',
            type: 'email',
            value: form.values.email,
            onChange: ev => form.handleChange(ev, onChangeEmail),
        },
    };

    return (
        <>
            <Page.Title>{t('email.title')}</Page.Title>
            <Page.Descr>{t('email.descr')}</Page.Descr>
            <Form.Form name="ContratosEmailForm" onSubmit={ev => form.handleSubmit(ev, onSubmit)}>
                <Form.Field {...fields.email} />
                {freeWarn && <Styled.Warn>{t('email.freeWarning')}</Styled.Warn>}
                <Form.Submt {...form} text={t('email.submit')} />
            </Form.Form>
        </>
    );
}
export default ContratosEmail;
